
export interface SRPErrorsInterface {

    srpNameErr: boolean;
    
    textFieldErrors: { 
        [key: string]: boolean;
    };

    moduleInformationErrors: {
        [key: string]: boolean;
    }; 

    machineListErrors: StateMachineListErrorsInterface[];

    preassemblyImageErrors: SRPDPreAssemblyImageErrorsInterface;
}

export interface StateMachineListErrorsInterface {
    [key: string]: any;
    variantListErrors: VariantListErrorsInterface[];
}
export interface VariantListErrorsInterface {
    [key: string]: any;
    clusterListErrors: ClusterListErrorsInterface[];
}

export interface ClusterListErrorsInterface {
    [key: string]: any;
    selectionCriteriaListErrors: SelectionCriteriaListErrorsInterface[];
}

export interface SelectionCriteriaListErrorsInterface {
    [key: string]: any;
}

export interface SRPDPreAssemblyImageErrorsInterface {
    [key: string]: string;
}


export const selectionCriteriaListErrorsTemplate: SelectionCriteriaListErrorsInterface = {

}

export const clusterListErrorsTemplate: ClusterListErrorsInterface = {

    selectionCriteriaListErrors: [
        {
            ...selectionCriteriaListErrorsTemplate
        }
    ],
}

export const variantListErrorsTemplate: VariantListErrorsInterface = {

    clusterListErrors: [
        {
            ...clusterListErrorsTemplate
        }
    ],
}

export const machineListErrorsTemplate: StateMachineListErrorsInterface = {

    variantListErrors: [
        {
            ...variantListErrorsTemplate
        }
    ],
}


export const srpErrorsTemplate = {

    srpNameErr: false,
    
    textFieldErrors: {},

    moduleInformationErrors: {}, 

    machineListErrors: [machineListErrorsTemplate],

    preassemblyImageErrors: {},
} as SRPErrorsInterface;